import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ShellDomainProvider } from '../standalone-packages/ecap3/core';
import { Subject } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { CommonService } from './common.service';
import { UrlResolverService } from './url/url-resolver.service';
@Injectable({
    providedIn: 'root'
})
export class MailAuthStatusService {
    private readonly urlResolver = inject(UrlResolverService);
    header: any = new HttpHeaders({
        'Content-Type': 'application/json'
    });
    isMailAuthorized: boolean | null = null;
    // Emits the user id of a user whose mail authorization just succeeded.
    // Screens that keep their own copy of an inspector's status listen to this to update it.
    readonly mailAuthorized$ = new Subject<string>();
    currentUsername: string = '';
    currentUserEmail: string = '';
    constructor(
        private http: HttpClient,
        private commonService: CommonService
    ) {
        this.isMailAuthorized = null;
    }

    getEmailAuthStatus(userId) {
        this.commonService.getCurrentRoleUser();
        const request = {
            Url: `${this.urlResolver.getExternalGenericUrl()}GetEmailAuthStatus`,
            Payload: {
                UserId: userId ? userId : null
            }
        };

        return this.http
            .post(request.Url, request.Payload, { headers: this.header, withCredentials: true, observe: 'response' })
            .pipe(
                map((response: any) => {
                    return response.body;
                })
            );
    }
}
